module.exports = __webpack_public_path__ + "img/logo_navbar.8486804a.png";